/* import __COLOCATED_TEMPLATE__ from './zoom-percentage.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import type Graph from '../../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsZoomPercentageComponent extends Component<Args> {
  get percentage(): string {
    return `${Math.round(this.args.graph.state.scale * 100)}%`;
  }
}
